import { t } from "i18next";
import { useNavigate } from "react-router";
// import logo from "../../../assets/images/logo.png";
import images from "../../../resources/images";
import config from "../../../config";
import { RESTAURANTS } from "../../../resources/config";
import icons, { iconsAlts } from "../../../resources/icons";
import * as links from "../../../utils/links";
import { DropDown } from "../../Common";
import classes from "../VfNavBar.module.css";

const NavBarWeb = ({
  homepageHandler,
  getPrimaryButtonByCountry,
  getInvolvedContent,
  getEntitiesContent,
  navigateToAboutUs,
  navigatedToTrademark,
  navigatedToCertifiedPartners,
  setSearchModalOpen,
  getTrademarkContent,
  logClickEvent,
}) => {
  const navigate = useNavigate();
  const isUS = config.currentCountry === "US";
  const isGB = process.env.REACT_APP_COUNTRY === "GB";
  const isIL = process.env.REACT_APP_COUNTRY === "IL";

  const navigateToRestaurants = () => {
    logClickEvent("restaurants");
    navigate(links.linkToSearch({ entityType: RESTAURANTS }));
  };

  return (
    <>
      <div className={classes.webContainer}>
        <div className={classes.leftContainer}>
          <>
            <img
              src={images.logo}
              className={classes.veganLogo}
              onClick={homepageHandler}
              alt={iconsAlts.veganLogo}
            />
          </>
          {
            <DropDown
              buttonComponent={
                <button type="button" className={classes.getInvolvedContainer}>
                  <p className={classes.getInvolved}>{t("entities")}</p>
                  <img
                    className={classes.getInvolvedIcon}
                    src={icons.greyArrowDown}
                    alt={iconsAlts.greenArrowDown}
                  />
                </button>
              }
              innerComponent={getEntitiesContent}
            />
          }
          <DropDown
            buttonComponent={
              <button type="button" className={classes.getInvolvedContainer}>
                <p className={classes.getInvolved}>{t("get_involved")}</p>
                <img
                  className={classes.getInvolvedIcon}
                  src={icons.greyArrowDown}
                  alt={iconsAlts.greenArrowDown}
                />
              </button>
            }
            innerComponent={getInvolvedContent}
          />
          {(!isIL) && (
            <DropDown
              buttonComponent={
                <button
                  type="button"
                  className={classes.trademarkContainer}
                  onClick={navigatedToTrademark}
                >
                  <p className={classes.trademark}>{t("trademark")}</p>
                  <img
                    style={{
                      filter:
                        "brightness(0) saturate(100%) invert(38%) sepia(95%) saturate(512%) hue-rotate(-17deg) brightness(103%) contrast(98%)",
                    }}
                    className={classes.getInvolvedIcon}
                    src={icons.greyArrowDown}
                    alt={iconsAlts.greenArrowDown}
                  />
                </button>
              }
              innerComponent={getTrademarkContent}
            />
          )}

          <button
            type="button"
            className={classes.aboutUs}
            onClick={navigateToAboutUs}
          >
            {t("about_us")}
          </button>
        </div>
        <div className={classes.rightContainer}>
          {getPrimaryButtonByCountry()}
          <button
            className={classes.searchContainer}
            onClick={() => setSearchModalOpen(true)}
          >
            <img
              src={icons.searchButtonIcon}
              alt={iconsAlts.searchButtonIcon}
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default NavBarWeb;
